import React, { useEffect } from "react";
import { useTrackingAnalytics } from "../hooks/useTrackingAnalytics";

/**
 * Wraps a component and automatically tracks a PostHog pageview on mount
 * @param WrappedComponent The component to wrap
 * @param extraProps Optional additional properties to send with the pageview
 */
export function withPageTracking(WrappedComponent, extraProps = {}) {
  return function TrackedComponent(props) {
    const { capturePageView } = useTrackingAnalytics();

    useEffect(() => {
      capturePageView(extraProps);
    }, []); // run once per mount

    return <WrappedComponent {...props} />;
  };
}
